export default __webpack_public_path__ + "static/media/burger_choose_resto.70a3cb65.png";